
import { Song } from '@/includes/firebase/fireStore';
import { defineComponent, PropType } from 'vue'
import {mapActions} from "vuex"
// interface Song{
//   modified_name:string,
//   display_name:string,
//   comment_count:number,
//   docId:string
// }

export default defineComponent({
  name:"SongItem",
  props:{
    song:{
      type:Object as PropType<Song>,
      required:true
    }
  },
  methods:{
    ...mapActions(['newSong'])
  }
});
